import { defineStore } from 'pinia';
import { storage } from '../utils/storage';
import DNSAPI from '../api/dns';

export const useConfigStore = defineStore('config', {
  state: () => ({
    apiToken: storage.get('api_token', ''),
    apiKey: storage.get('api_key', ''),
    email: storage.get('email', ''),
    isConfigured: false,
    isValidating: false,
    validationError: null,
  }),

  getters: {
    hasApiToken: (state) => !!state.apiToken,
    hasApiKey: (state) => !!(state.apiKey && state.email),
    hasValidConfig: (state) => state.isConfigured && (state.hasApiToken || state.hasApiKey),
    authConfig: (state) => {
      if (state.apiToken) {
        return { apiToken: state.apiToken };
      } else if (state.apiKey && state.email) {
        return { apiKey: state.apiKey, email: state.email };
      }
      return null;
    },
  },

  actions: {
    /**
     * 保存 API Token
     */
    setApiToken(token) {
      this.apiToken = token;
      storage.set('api_token', token);

      // 清除 API Key 和 Email
      if (token) {
        this.apiKey = '';
        this.email = '';
        storage.remove('api_key');
        storage.remove('email');
      }
    },

    /**
     * 保存 API Key 和 Email
     */
    setApiKey(apiKey, email) {
      this.apiKey = apiKey;
      this.email = email;
      storage.set('api_key', apiKey);
      storage.set('email', email);

      // 清除 API Token
      if (apiKey && email) {
        this.apiToken = '';
        storage.remove('api_token');
      }
    },

    /**
     * 验证配置
     */
    async validateConfig() {
      this.isValidating = true;
      this.validationError = null;

      try {
        const config = this.authConfig;
        if (!config) {
          throw new Error('No authentication credentials provided');
        }

        console.log('Validating config with:', {
          hasToken: !!config.apiToken,
          hasKey: !!config.apiKey,
          hasEmail: !!config.email
        });

        // 尝试获取 zones 列表来验证
        const client = new DNSAPI(config);
        const zones = await client.listZones({ per_page: 1 });

        console.log('Validation successful, zones:', zones);

        this.isConfigured = true;
        return { success: true, message: 'Configuration validated successfully' };
      } catch (error) {
        console.error('Validation failed:', error);
        this.isConfigured = false;
        this.validationError = error.message;
        return { success: false, message: error.message };
      } finally {
        this.isValidating = false;
      }
    },

    /**
     * 清除配置
     */
    clearConfig() {
      this.apiToken = '';
      this.apiKey = '';
      this.email = '';
      this.isConfigured = false;
      this.validationError = null;

      storage.remove('api_token');
      storage.remove('api_key');
      storage.remove('email');
    },

    /**
     * 从 localStorage 加载配置
     */
    loadConfig() {
      this.apiToken = storage.get('api_token', '');
      this.apiKey = storage.get('api_key', '');
      this.email = storage.get('email', '');

      // 如果有配置，自动验证
      if (this.hasApiToken || this.hasApiKey) {
        this.validateConfig();
      }
    },
  },
});
